/* Así funciona · Limpiador a Vapor de Alta Presión (2042338)
   La cocina de la tienda con el limpiador REAL (el mismo recorte de la foto principal pegado en el ambiente). La
   clienta mantiene presionado sobre el zócalo del mueble y recorre la junta: la mano real con la pistola gira un
   poco en la muñeca para apuntar (máx. 11°), sale el chorro de vapor REAL (la forma y textura del vapor de la foto
   del fabricante, enderezado sobre el eje de la boquilla) y, donde pega, la junta piso/mueble y la película de abajo
   del zócalo (los mismos píxeles un poco más oscuros) quedan como en la foto. Lo de detrás de la mano está rehecho
   con píxeles de la misma foto (sin IA). Ficha: vapor a presión, boquillas y cepillos intercambiables, ajuste de
   niveles, cable de 2,5 m. Piezas: tiendas/nayhogar/funciona/limpiador-a-vapor-de-alta-presion/hacer.py */
NHF.escena('limpiador-a-vapor-de-alta-presion', function (E) {
  const D = /*DATOS*/{"w":1600,"h":1600,"pistola":{"pivote":[130.0,1055.0],"boquilla":[489.0,938.0],"eje":-14.8},"zocalo":{"x0":812.0,"y0":848.0,"pend":0.232,"alto":46.0,"x1":1250.0},"mano":{"src":"fn-limpiador-a-vapor-de-alta-presion-mano.webp","caja":[0,924,493,352]},"base":{"src":"fn-limpiador-a-vapor-de-alta-presion-fondo.webp","caja":[0,600,1600,900]},"vapor":{"src":"fn-limpiador-a-vapor-de-alta-presion-vapor.webp","w":402,"h":240,"boquilla":[0,156]},"sucio":{"src":"fn-limpiador-a-vapor-de-alta-presion-sucio.webp","caja":[828,830,425,159]},"rejilla":{"x":828,"y":830,"dx":16,"dy":8,"cols":27,"filas":20,"peso":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.06,0.06,0.04,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.05,0.08,0.09,0.1,0.08,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.14,0.39,0.29,0.18,0.16,0.12,0.12,0.07,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.06,0.34,0.8,0.81,0.51,0.25,0.22,0.17,0.07,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.18,0.55,0.87,0.84,0.57,0.3,0.18,0.12,0.11,0.06,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.07,0.16,0.45,0.84,0.92,0.69,0.41,0.25,0.13,0.06,0.06,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.04,0.16,0.46,0.86,1.0,0.76,0.32,0.1,0.11,0.09,0.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.06,0.07,0.1,0.21,0.46,0.84,0.94,0.62,0.26,0.15,0.15,0.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.05,0.04,0.05,0.11,0.21,0.24,0.36,0.67,0.86,0.71,0.49,0.21,0.08,0.16,0.09,0.04,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.12,0.1,0.09,0.08,0.08,0.24,0.62,0.95,0.84,0.48,0.37,0.2,0.12,0.08,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.05,0.05,0.05,0,0,0.07,0.23,0.61,0.94,0.96,0.6,0.26,0.13,0.04,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.11,0.27,0.6,0.92,0.92,0.56,0.17,0.07,0.1,0.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.08,0.12,0.15,0.25,0.54,0.88,0.84,0.52,0.29,0.11,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.06,0.08,0.1,0.11,0.18,0.29,0.38,0.75,0.78,0.34,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.04,0.05,0.1,0.16,0.11,0.07,0.14,0.28,0.28,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.06,0.06,0.07,0.06,0.08,0.07,0.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.05,0.07,0.06,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}}/*FIN*/;
  const S = E.lienzo({ w: D.w, h: D.h, vista: [130, 610, 1180, 720], vistaMovil: [96, 640, 1190, 860] });
  E.titulo('Pásale [el vapor].', 'Mantén presionado sobre el zócalo del mueble y recórrelo: la pistola apunta y el vapor afloja la mugre de la junta.');
  E.conSonido();
  S.cargando(true);

  /* ---------- capas (fotos reales) ---------- */
  S.img(D.base.src, D.base.caja, { z: 1, alt: 'Limpiador a vapor en el piso de una cocina, con la pistola en la mano' });
  const SU = D.sucio.caja;
  const sucio = S.canvas(SU, { z: 2, res: Math.min(1, (window.devicePixelRatio || 1) * 0.75) });
  const P = D.pistola;
  const grupo = S.grupo([0, 0, D.w, D.h], { z: 4 });
  grupo.style.transformOrigin = P.pivote[0] + 'px ' + P.pivote[1] + 'px';
  S.img(D.mano.src, D.mano.caja, { en: grupo, alt: 'Mano con la pistola de vapor' });
  const VC = [380, 620, 1000, 520];
  const vap = S.canvas(VC, { z: 6, res: Math.min(0.9, (window.devicePixelRatio || 1) * 0.6) });
  let tex = null, imgSucio = null;
  E.cargar([D.base.src, D.mano.src, D.vapor.src, D.sucio.src]).then(r => { tex = r[2]; imgSucio = r[3]; S.cargando(false); pintarSucio(); });

  /* ---------- geometría real ---------- */
  const Z = D.zocalo, rad = g => g * Math.PI / 180;
  const junta = x => Z.y0 + (x - Z.x0) * Z.pend + 4;                 // unión piso / zócalo
  const XMIN = Z.x0 + 24, XMAX = Z.x1 - 26, TMAX = 11;
  function boquilla(th) {                                             // punta de la boquilla con la muñeca girada th°
    const c = Math.cos(rad(th)), s = Math.sin(rad(th));
    const dx = P.boquilla[0] - P.pivote[0], dy = P.boquilla[1] - P.pivote[1];
    return [P.pivote[0] + dx * c - dy * s, P.pivote[1] + dx * s + dy * c];
  }
  function apuntar(x) {                                               // el giro que lleva el chorro al punto del zócalo
    const T = [x, junta(x) - 14];
    let th = ST.th;
    for (let i = 0; i < 5; i++) { const N = boquilla(th); th = Math.atan2(T[1] - N[1], T[0] - N[0]) * 180 / Math.PI - P.eje; }
    return E.clamp(th, 0, TMAX);
  }

  /* ---------- estado ---------- */
  const ST = { th: 0, meta: 0, x: 900, on: false, k: 0, crece: 0, limpio: 0, listo: false, auto: false, quieto: 0, vio: false };

  /* ---------- panel ---------- */
  E.pasos(['Mantén presionado sobre el zócalo', 'Recórrelo de lado a lado', 'Junta limpia']);
  E.paso(0);
  const lect = E.lectura({ etiqueta: 'Junta limpia' }); lect.poner('0', '%');
  const bAuto = E.boton('Hazlo por mí', () => auto(), { icono: 'mano' });
  E.nota('Solo agua y vapor a presión. Trae ajuste de niveles, boquillas y cepillos intercambiables y cable de 2,5 m. En la demostración el tiempo pasa rápido.');

  /* ---------- zona del zócalo: mantener presionado = soltar vapor ---------- */
  const zona = S.toque([640, 700, 680, 380], { etiqueta: 'Zócalo del mueble: mantén presionado para soltar el vapor' });
  zona.style.touchAction = 'pan-y'; zona.style.cursor = 'crosshair';
  // anillo que invita, en el zócalo (solo marca; la zona tocable es toda la franja)
  const anillo = S.div([884, 828, 92, 92], { z: 7, clase: 'nhf-toque is-redonda is-pista' });
  anillo.style.pointerEvents = 'none';
  const desde = e => { const p = S.punto(e); ST.x = E.clamp(p.x, XMIN, XMAX); };
  zona.addEventListener('pointerdown', e => {
    if (e.button > 0) return; ST.auto = false; desde(e); vapor(true);
    try { zona.setPointerCapture(e.pointerId); } catch (x) {}
    anillo.hidden = true;
  });
  zona.addEventListener('pointermove', e => { if (ST.on && !ST.auto) desde(e); });
  const soltar = () => { if (!ST.auto) vapor(false); };
  zona.addEventListener('pointerup', soltar); zona.addEventListener('pointercancel', soltar); zona.addEventListener('lostpointercapture', soltar);
  zona.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); auto(); } });

  let ruido = null;
  function vapor(si) {
    if (si === ST.on) return;
    ST.on = si;
    if (si) { ST.crece = 0; E.vibrar(10); if (E.sonido.activo) ruido = E.sonido.ruido(0, 0.03, 2600); }
    else if (ruido) { ruido.parar(); ruido = null; }
    guia();
  }

  /* ---------- la junta sucia se limpia donde pega el vapor ---------- */
  const G = D.rejilla, resto = G.peso.slice(), total = G.peso.reduce((a, b) => a + b, 0);
  function pintarSucio() { sucio.limpiar(); if (imgSucio) sucio.ctx.drawImage(imgSucio, SU[0], SU[1], SU[2], SU[3]); }
  const RX = 64, RY = 46, ROT = Math.atan(Z.pend);
  function limpiar(x, fuerza) {
    const cy = junta(x) + 2, ctx = sucio.ctx;
    ctx.save(); ctx.globalCompositeOperation = 'destination-out';
    ctx.translate(x, cy); ctx.rotate(ROT); ctx.scale(1, RY / RX);
    const g = ctx.createRadialGradient(0, 0, RX * 0.35, 0, 0, RX);
    g.addColorStop(0, 'rgba(0,0,0,' + fuerza + ')'); g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, RX, 0, 6.2832); ctx.fill(); ctx.restore();
    let quedan = 0;
    for (let j = 0; j < G.filas; j++) for (let i = 0; i < G.cols; i++) {
      const n = j * G.cols + i; if (!resto[n]) continue;
      const px = G.x + (i + 0.5) * G.dx - x, py = G.y + (j + 0.5) * G.dy - cy;
      const u = px * Math.cos(ROT) + py * Math.sin(ROT), v = -px * Math.sin(ROT) + py * Math.cos(ROT);
      if ((u / RX) ** 2 + (v / RY) ** 2 < 0.8) resto[n] = Math.max(0, resto[n] - G.peso[n] * fuerza * 0.42);
      quedan += resto[n];
    }
    ST.limpio = Math.round(100 * (1 - quedan / total));
    lect.poner(String(Math.min(100, ST.limpio)), '%');
    if (ST.limpio > 25) ST.vio = true;
    if (ST.limpio >= 93 && !ST.listo) terminar();
  }
  function terminar() {
    ST.listo = true; ST.auto = false;
    const ctx = sucio.ctx;
    E.animarP(800, k => { ctx.save(); ctx.globalCompositeOperation = 'destination-out'; ctx.fillStyle = 'rgba(0,0,0,' + (0.2 * k) + ')'; ctx.fillRect(SU[0], SU[1], SU[2], SU[3]); ctx.restore(); });
    lect.poner('100', '%'); E.sonido.bip(1700);
    setTimeout(() => vapor(false), 500);
    guia();
  }

  /* ---------- vapor: el chorro real + soplos que viajan + la nube que se abre contra el zócalo ---------- */
  const PUF = [];
  function soplo(x, y, vx, vy, vida, r0, r1, a) { if (PUF.length < 140) PUF.push({ x, y, vx, vy, t: 0, vida, r0, r1, a, f: Math.random() * 6.28 }); }
  let tAcum = 0, tLimpia = 0;
  E.bucle((t, dt) => {
    // muñeca: apunta al punto del zócalo con un poco de inercia; sin vapor vuelve sola a la foto (0°)
    if (ST.on) { ST.quieto = 0; ST.meta = apuntar(ST.x); }
    else { ST.quieto += dt; if (ST.quieto > 1.4 && !ST.auto) ST.meta = 0; }
    ST.th += (ST.meta - ST.th) * Math.min(1, dt * 7);
    if (Math.abs(ST.th - ST.meta) < 0.01) ST.th = ST.meta;
    grupo.style.transform = ST.th ? 'rotate(' + ST.th.toFixed(3) + 'deg)' : '';
    // intensidad del chorro (sube rápido, se corta en ~0,3 s)
    ST.k += ((ST.on ? 1 : 0) - ST.k) * Math.min(1, dt * (ST.on ? 9 : 6));
    if (ST.on) ST.crece = Math.min(1, ST.crece + dt * 4.5);
    const N = boquilla(ST.th);
    const T = [ST.x, junta(ST.x) - 14];
    const d = Math.hypot(T[0] - N[0], T[1] - N[1]);
    const ang = Math.atan2(T[1] - N[1], T[0] - N[0]);
    vap.limpiar();
    const ctx = vap.ctx;
    if (tex && ST.k > 0.01) {
      const V = D.vapor, kL = d / (V.w * 0.92), kW = E.clamp(0.78 + 0.32 * kL, 0.85, 1.35);
      const largo = V.w * (ST.on ? ST.crece : 1);
      for (let c = 0; c < 2; c++) {
        ctx.save();
        ctx.translate(N[0], N[1]); ctx.rotate(ang);
        ctx.scale(kL * (c ? 1.04 : 1), kW * (c ? -0.86 : 1));
        ctx.globalAlpha = ST.k * (c ? 0.4 + 0.16 * Math.sin(t * 13 + 1.7) : 0.74 + 0.14 * Math.sin(t * 17));
        ctx.beginPath(); ctx.rect(0, -V.h, largo, V.h * 2); ctx.clip();       // el chorro nace en la boquilla y avanza
        ctx.drawImage(tex, 0, -V.boquilla[1], V.w, V.h);
        ctx.restore();
      }
    }
    // soplos: salen de la boquilla y viajan por el eje; al llegar se abren contra el zócalo
    tAcum += dt;
    if (ST.on && ST.crece > 0.6 && tAcum > 0.03) {
      tAcum = 0;
      const v = d / 0.42;
      soplo(N[0], N[1], Math.cos(ang) * v, Math.sin(ang) * v, 0.42, 5, 26, 0.10);
      for (let i = 0; i < 2; i++) {
        const lado = Math.random() < 0.5 ? -1 : 1, vv = 40 + Math.random() * 70;
        soplo(T[0] + (Math.random() - .5) * 30, T[1] + (Math.random() - .5) * 12, lado * vv * Math.cos(ROT), lado * vv * Math.sin(ROT) - 18 - Math.random() * 25, 1.1 + Math.random() * 0.6, 16, 66, 0.095);
      }
    }
    for (let i = PUF.length - 1; i >= 0; i--) {
      const p = PUF[i]; p.t += dt; if (p.t > p.vida) { PUF.splice(i, 1); continue; }
      const k = p.t / p.vida;
      p.x += p.vx * dt + Math.sin(p.t * 3 + p.f) * 6 * dt; p.y += p.vy * dt;
      p.vx *= 1 - Math.min(1, dt * 1.6); p.vy *= 1 - Math.min(1, dt * 1.6); p.vy -= 10 * dt;
      const r = p.r0 + (p.r1 - p.r0) * Math.sqrt(k), a = p.a * Math.sin(Math.PI * Math.min(1, k * 1.2));
      const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, r);
      g.addColorStop(0, 'rgba(255,255,255,' + a.toFixed(3) + ')'); g.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x, p.y, r, 0, 6.2832); ctx.fill();
    }
    // donde pega el vapor la junta queda limpia (el vapor afloja la mugre; demostración acelerada)
    tLimpia += dt;
    if (ST.on && ST.crece > 0.8 && !ST.listo && tLimpia > 0.06) { tLimpia = 0; limpiar(ST.x, 0.05); guia(); }
  });

  /* ---------- guía ---------- */
  function guia() {
    let p = 0, txt = 'Mantén presionado sobre el zócalo del mueble', ic = 'toca';
    if (ST.on || ST.limpio > 0) { p = 1; txt = 'Sin soltar, recorre el zócalo de lado a lado'; ic = 'flechas'; }
    if (ST.vio && !ST.on) { p = 1; txt = 'Mantén presionado donde quede oscuro'; ic = 'toca'; }
    if (ST.listo) { p = 3; txt = ''; }
    E.paso(p); S.pista(txt || null, ic);
    if (ST.listo) { bAuto.hidden = true; E.listo('La mugre de la junta se afloja con vapor, sin tallar tanto. Con sus boquillas y cepillos llegas a la estufa, el baño y las esquinas.', reiniciar); }
  }

  /* ---------- "Hazlo por mí": recorre el zócalo de punta a punta ---------- */
  async function auto() {
    if (ST.auto || ST.listo) return;
    ST.auto = true; bAuto.hidden = true; anillo.hidden = true;
    ST.x = XMIN; vapor(true);
    // recorre el zócalo de punta a punta y después vuelve a donde más mugre quede, hasta dejar la junta limpia
    for (let v = 0; v < 3 && ST.auto && !ST.listo; v++) {
      const a = v % 2 ? [XMAX, XMIN] : [XMIN, XMAX];
      await E.animarP(2600, k => { if (ST.auto) ST.x = E.lerp(a[0], a[1], k); }, k => k);
    }
    for (let v = 0; v < 16 && ST.auto && !ST.listo; v++) {
      let mejor = -1, mp = 0;
      resto.forEach((r, n) => { if (r > mp) { mp = r; mejor = n; } });
      if (mejor < 0) break;
      const x = E.clamp(G.x + (mejor % G.cols + 0.5) * G.dx, XMIN, XMAX), x0 = ST.x;
      await E.animarP(450, k => { if (ST.auto) ST.x = E.lerp(x0, x, k); });
      await E.esperar(500);
    }
    if (ST.auto) { ST.auto = false; vapor(false); }
    if (!ST.listo) bAuto.hidden = false;
  }

  function reiniciar() {
    E.noListo(); ST.listo = false; ST.auto = false; ST.vio = false; ST.limpio = 0; vapor(false);
    for (let n = 0; n < resto.length; n++) resto[n] = G.peso[n];
    pintarSucio(); lect.poner('0', '%'); bAuto.hidden = false; anillo.hidden = false; guia();
  }
  S.pista('Mantén presionado sobre el zócalo del mueble', 'toca');
});
